var _rect, _rect2, _rect3, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 36,
    viewBox: "0 0 88 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 35,
    rx: 17.5,
    fill: "#58DF6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 35,
    rx: 17.5,
    stroke: "#58DF6D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_14692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_14692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 7,
    width: 22,
    height: 22
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_14692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.672 24.3903C28.2908 24.7362 27.7092 24.7362 27.328 24.3903L26.985 24.079C25.8067 23.0045 24.8325 22.0777 24.0625 21.2984C23.2925 20.5191 22.68 19.8195 22.225 19.1996C21.77 18.5797 21.4521 18.01 21.2713 17.4905C21.0904 16.9709 21 16.4396 21 15.8965C21 14.7866 21.3675 13.8597 22.1025 13.1158C22.8375 12.3719 23.7533 12 24.85 12C25.4567 12 26.0342 12.1299 26.5825 12.3896C27.1308 12.6494 27.6033 13.0154 28 13.4877C28.3967 13.0154 28.8692 12.6494 29.4175 12.3896C29.9658 12.1299 30.5433 12 31.15 12C32.2467 12 33.1625 12.3719 33.8975 13.1158C34.6325 13.8597 35 14.7866 35 15.8965C35 16.4396 34.9096 16.9709 34.7288 17.4905C34.5479 18.01 34.23 18.5797 33.775 19.1996C33.32 19.8195 32.7075 20.5191 31.9375 21.2984C31.1675 22.0777 30.1933 23.0045 29.015 24.079L28.672 24.3903Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.285 23.6562C48.1912 23.6406 46.0037 22.4062 46.0037 18.2188C46.0037 14.2812 47.7069 12.0312 50.4256 12.0312C52.5037 12.0312 53.9569 13.3281 54.2225 15.125H52.5194C52.3006 14.2031 51.5662 13.5312 50.4256 13.5312C48.6756 13.5312 47.66 15.0625 47.66 17.6094H47.785C48.3944 16.6562 49.4569 16.0781 50.6912 16.0781C52.7069 16.0781 54.3319 17.625 54.3319 19.7969C54.3319 21.9844 52.7225 23.6719 50.285 23.6562ZM50.2694 22.2188C51.6444 22.2188 52.66 21.1562 52.66 19.8281C52.66 18.5312 51.6756 17.4844 50.3162 17.4844C48.9256 17.4844 47.8787 18.5781 47.8631 19.8438C47.8787 21.0938 48.8787 22.2188 50.2694 22.2188ZM59.9338 23.6562C57.84 23.6406 55.6525 22.4062 55.6525 18.2188C55.6525 14.2812 57.3556 12.0312 60.0744 12.0312C62.1525 12.0312 63.6056 13.3281 63.8713 15.125H62.1681C61.9494 14.2031 61.215 13.5312 60.0744 13.5312C58.3244 13.5312 57.3088 15.0625 57.3088 17.6094H57.4338C58.0431 16.6562 59.1056 16.0781 60.34 16.0781C62.3556 16.0781 63.9806 17.625 63.9806 19.7969C63.9806 21.9844 62.3713 23.6719 59.9338 23.6562ZM59.9181 22.2188C61.2931 22.2188 62.3088 21.1562 62.3088 19.8281C62.3088 18.5312 61.3244 17.4844 59.965 17.4844C58.5744 17.4844 57.5275 18.5781 57.5119 19.8438C57.5275 21.0938 58.5275 22.2188 59.9181 22.2188Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_14692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(17 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.512e00ebf320fb5b06a8a7a71084ac0f.svg";
export { ForwardRef as ReactComponent };